import { ToggleList } from '../../../../shared/components/cards/toggle-list/ToggleList'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface RedirectLinksCellProps {
  id?: string
  redirects: string[]
  additionalRedirects: string[][]
  found?: string
  title: string
  onToggleExpand?: (isShow: boolean, key: string) => void
}

export const RedirectLinksCell = ({
  id,
  redirects,
  additionalRedirects,
  onToggleExpand,
}: RedirectLinksCellProps) => {
  const { t } = useTranslation()

  const allRedirects = [...redirects, ...(additionalRedirects ? additionalRedirects.flat() : [])]

  return (
    <ToggleList
      list={allRedirects}
      title={t('pages.adOverview.links')}
      onToggle={(isShow) => {
        if (onToggleExpand) onToggleExpand(isShow, `${id}`)
      }}
    />
  )
}
